export const selectStyles = {
  control: (base: any) => ({
    ...base,
    minHeight: '40px',
    fontSize: '16px',
    borderRadius: '8px',
    borderColor: '#e2e8f0',
    '&:hover': { borderColor: '#005fcc' },
  }),
  menu: (base: any) => ({
    ...base,
    zIndex: 9999,
  }),
  menuList: (base: any) => ({
    ...base,
    maxHeight: '250px',
  }),
  option: (base: any, state: any) => ({
    ...base,
    padding: '12px 15px',
    fontSize: '15px',
    backgroundColor: state.isDisabled
      ? '#f8f9fa'
      : state.isSelected
        ? '#005fcc'
        : state.isFocused
          ? '#f0f7ff'
          : 'transparent',
    color: state.isDisabled ? '#a0aec0' : state.isSelected ? '#fff' : '#2d3748',
    cursor: state.isDisabled ? 'not-allowed' : 'default',
  }),
  singleValue: (base: any) => ({ ...base, color: '#2d3748' }),
};